import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ArtikelService } from '../services/artikel.service';

@Component({
  selector: 'sws-infohome',
  templateUrl: './infohome.component.html',
  styleUrls: ['./infohome.component.scss']
})
export class InfohomeComponent implements OnInit {

  constructor(public authService: AuthService,
              private router: Router,
              private route: ActivatedRoute,
              private artSuche: ArtikelService) {
                
               }

  ngOnInit() {
  
    
  }

/* zur Seite Anmeldung */
  login() {
       /* Programm startet in Infohome */
      this.router.navigateByUrl('/login');
   
  }

  /* Abmeldung */
  logout() {
    this.authService.logout();
    this.artSuche.Initialisieren();
    this.router.navigateByUrl('/home');
  }

/* wenn angemeldet, zur Artikelsuche / Lagerinfo */
  zurListe() {
       /* Programm startet in Infohome */
      this.router.navigateByUrl('/infopage');
   
  }
}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/infohome/infohome.component.ts